import {
  SimpleTable, DetailStack, HStack,
  ActionIconProps,
  Badge,
} from '@doveit/bricks';
import { formatEuro, formatPercentage } from '@doveit/hammer';
import React from 'react';
import { ViewAgentSmallPreview } from '../../../agent/components';
import { jobTitleLabels, commissionTypeLabels } from '../../../labels';
import { Commission } from '../../../providers/api/dtos';

export interface InvoiceCommissionTableRowProps extends React.AriaAttributes {
  commission: Commission,
  actions?: React.ReactElement<ActionIconProps>[],
}

const InvoiceCommissionTableRow: React.FC<InvoiceCommissionTableRowProps> = ({
  commission,
  actions = [],
  'aria-label': ariaLabel = 'invoice-commission-table-row',
}) => (
  <SimpleTable.Row
    key={`invoice-commission-${commission.agentId}`}
    aria-label={ariaLabel}
  >
    <SimpleTable.Cell>
      <ViewAgentSmallPreview
        agentIdOrEmail={commission.agentId}
        size="S"
        details={(agent) => jobTitleLabels[agent.jobTitle]}
      />
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Badge
        label={commissionTypeLabels[commission.type]}
        size="XS"
      />
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <DetailStack label="Percentuale">
        {formatPercentage(commission.percentage)}
      </DetailStack>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <DetailStack label="Importo">
        {formatEuro(commission.amount)}
      </DetailStack>
    </SimpleTable.Cell>
    <SimpleTable.Cell align="right">
      {actions.length > 0 && (
        <HStack>
          {actions.map((action) => (
            <React.Fragment key={action.key}>
              {action}
            </React.Fragment>
          ))}
        </HStack>
      )}
    </SimpleTable.Cell>
  </SimpleTable.Row>
);

export default InvoiceCommissionTableRow;
